module.exports = __webpack_public_path__ + "img/thumbnail_Capybara_m_albino.cc9f7240.png";